export const OKTA_INTERNAL_CONFIG = {
  issuer: `${window._env_?.REACT_APP_INTERNAL_ISSUER || process.env?.REACT_APP_INTERNAL_ISSUER}`,
  clientId: `${window._env_?.REACT_APP_GSPT_CLIENT_ID || process.env?.REACT_APP_GSPT_CLIENT_ID}`,
  redirectUri: `${window._env_?.REACT_APP_OKTA_REDIRECT_URL || process.env?.REACT_APP_OKTA_REDIRECT_URL}`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
}